import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'Un depósito es dónde se aloja un fluido del equipo: cárter de motor, tanque hidráulico, tanque de combustible, etc.',
    'No confundir con Componente (una pieza mecánica): el depósito se usa para las capacidades de llenado de cada equipo.',
    'Sé específico: "Cárter de motor" es mejor que "Motor".',
    'Podés asociar cada depósito a un sistema para filtrarlo más rápido al armar las tareas.',
  ],
  nextSteps: [
    'En el detalle de un equipo, pestaña Repuestos → Capacidades de llenado, asigná a cada depósito su fluido y capacidad máxima.',
    'En las tareas que impliquen un cambio de fluido, recordá asignarle el depósito correspondiente, así en las planillas de mantenimiento, podes completar automáticamente el aceite a utilizar.',
  ],
};

const ConfiguracionDepositos = () => (
  <ConfiguracionBase
    apiEndpoint="depositos"
    titulo="Depósitos"
    descripcion="Depósitos de fluidos de los equipos (cárter, tanque hidráulico, tanque de combustible, etc.)"
    icon="fas fa-fill-drip"
    compact
    help={HELP}
  />
);

export default ConfiguracionDepositos;
